import {BaseService} from './BaseService';
import decode from 'jwt-decode';
export default class IncubationService extends BaseService {
  getProfile() {
      return decode(this.getToken());
  }
  uploadFile (numero, startDate, endDate, file) {
    const data = new FormData();
    const currentUser = this.getProfile();
    data.append('file', file);
    data.append('announcement', numero);
    data.append('startdate', startDate);
    data.append('enddate', endDate);
    data.append('createdby', currentUser.username);

    return fetch(`${this.domain}/incubation/announcement`, {
          headers : {'Authorization':'Bearer ' + this.getToken()},
          method: 'POST',
          body: data,
        })
        .then(this._checkStatus)
        .then( response => {
          return Promise.resolve(response);
        });
  }
  createAnnouncement (numero, startDate, endDate, file) {
    const data = new FormData();
    const currentUser = this.getProfile();
    data.append('file', file);
    data.append('announcement', numero);
    data.append('startdate', startDate);
    data.append('enddate', endDate);
    data.append('createdby', currentUser.username);

    return fetch(`${this.domain}/incubation/announcement`, {
          headers : {'Authorization':'Bearer ' + this.getToken()},
          method: 'POST',
          body: data,
        })
        .then(this._checkStatus)
        .then( response => {
          return Promise.resolve(response);
        });
  }
  updateAnnouncement (numero, startDate, endDate, file) {
    const data = new FormData();
    const currentUser = this.getProfile();
    data.append('file', file);
    data.append('announcement', numero);
    data.append('startdate', startDate);
    data.append('enddate', endDate);
    data.append('createdby', currentUser.username);

    return fetch(`${this.domain}/incubation/announcement`, {
          headers : {'Authorization':'Bearer ' + this.getToken()},
          method: 'PUT',
          body: data,
        })
        .then(this._checkStatus)
        .then( response => {
          return Promise.resolve(response);
        });
  }
  getAnnouncement(numero) {
    return this.fetch(`${this.domain}/incubation/announcement?number=${numero}`, {
      method: 'GET'
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  getPreEvaluation(id) {
    return this.fetch(`${this.domain}/incubation/pre-evaluation?id=${id}`, {
      method: 'GET'
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  getProjectStatistics(id) {
    return this.fetch(`${this.domain}/incubation/proyect/statistics?id=${id}`, {
      method: 'GET'
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  disablePreEvaluation(id) {
    const data = { id: id };
    return this.fetch(`${this.domain}/incubation/disablePreEvaluation`, {
      method: 'PUT',
      body: JSON.stringify(data),
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
  savePreEvaluation(id, respuestas) {
      var currentUser = this.getProfile();
      var data = { evaluacion: {} };
      data.evaluacion['respuestas'] = respuestas;
      data.evaluacion['idproyectoincubacion'] = id;
      data.evaluacion['createdby'] = currentUser.username;

      return this.fetch(`${this.domain}/incubation/pre-evaluation`, {
          method: 'POST',
          body: JSON.stringify(data)
      }).then(res => {
          return Promise.resolve(res);
      })
  }
  preSelect(idsProyectos) {
      //var currentUser = this.getProfile();
      var data = { estado: {proyectosid: idsProyectos, estadoid: 3 } };

      return this.fetch(`${this.domain}/incubation/proyect/setstatus`, {
          method: 'POST',
          body: JSON.stringify(data)
      }).then(res => {
          return Promise.resolve(res);
      })
  }
  preIncubate(idsProyectos) {
      //var currentUser = this.getProfile();
      var data = { estado: {proyectosid: idsProyectos, estadoid: 4 } };

      return this.fetch(`${this.domain}/incubation/proyect/setstatus`, {
          method: 'POST',
          body: JSON.stringify(data)
      }).then(res => {
          return Promise.resolve(res);
      })
  }
  incubate(idsProyectos) {
      //var currentUser = this.getProfile();
      var data = { estado: {proyectosid: idsProyectos, estadoid: 5 } };

      return this.fetch(`${this.domain}/incubation/proyect/setstatus`, {
          method: 'POST',
          body: JSON.stringify(data)
      }).then(res => {
          return Promise.resolve(res);
      })
  }
  postIncubate(idsProyectos) {
    //var currentUser = this.getProfile();
    var data = { estado: {proyectosid: idsProyectos, estadoid: 6 } };

    return this.fetch(`${this.domain}/incubation/proyect/setstatus`, {
      method: 'POST',
      body: JSON.stringify(data)
    }).then(res => {
      return Promise.resolve(res);
    })
  }
  archive(idsProyectos) {
    //var currentUser = this.getProfile();
    var data = { estado: {proyectosid: idsProyectos, estadoid: 7 } };

    return this.fetch(`${this.domain}/incubation/proyect/setstatus`, {
      method: 'POST',
      body: JSON.stringify(data)
    }).then(res => {
      return Promise.resolve(res);
    })
  }
  assignProject(ids, users) {
    let currentUser = this.getProfile();
    let proyects = {"ids": ids, "users": users.value, "createdby": currentUser.username};

    return this.fetch(`${this.domain}/incubation/assign`, {
        method: 'POST',
        body: JSON.stringify({
            "proyects": proyects
          })
    }).then(res => {
        return Promise.resolve(res);
    })
  }
  getAssignedProyects(convocatoria) {
    return this.fetch(`${this.domain}/incubation/assigned-projects?convocatoria=${convocatoria}`, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
  saveEvaluation(projects) {
      return this.fetch(`${this.domain}/incubation/evaluation`, {
          method: 'POST',
          body: JSON.stringify({
            "evaluacion": projects,
          })
      }).then(res => {
          return Promise.resolve(res);
      })
  }
  getProject(id, state) {
    const url = new URL(`${this.domain}/incubation/get-project`);
    const params = { id, state };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
  saveTask(tarea, id) {
      var currentUser = this.getProfile();
      const data = {'tarea': tarea, 'id': id, 'createdby': currentUser.username};
      return this.fetch(`${this.domain}/incubation/task`, {
          method: 'POST',
          body: JSON.stringify({
            data,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  deleteTask(idtarea, idproyecto) {
      const data = {'idtarea': idtarea, 'idproyecto': idproyecto};
      return this.fetch(`${this.domain}/incubation/task`, {
          method: 'DELETE',
          body: JSON.stringify({
            data,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  uploadTaskFile(archivo, idproyecto) {
    var currentUser = this.getProfile();
    const data = new FormData();
    data.append('file', archivo.file);
    data.append('name', archivo.name);
    data.append('description', archivo.description);
    data.append('idproyecto', idproyecto);
    data.append('createdby', currentUser.username);
      return this.fetch(`${this.domain}/incubation/task/file`, {
          method: 'POST',
          body: JSON.stringify({
            data,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  getPreselectedProjects(convocatoria) {
    return this.fetch(`${this.domain}/incubation/pre-selections?convocatoria=${convocatoria}`, {
        method: 'GET',
    }).then(res => {
        return Promise.resolve(res);
    });
  }

  calificateProject(id, calificacion) {
    const evaluacion = {'idproyectoincubacion': id, 'valor': calificacion};
    return this.fetch(`${this.domain}/incubation/pre-selection`, {
        method: 'POST',
        body: JSON.stringify({
          evaluacion,
        })
    }).then(res => {
        return Promise.resolve(res);
    });
  }
  getCoordinadorTabData(convocatoria) {
    const url = new URL(`${this.domain}/incubation/pre-selection/coordinador`);
    if (convocatoria) {
      const params = { convocatoria };
      url.search = new URLSearchParams(params)
    }
    return this.fetch(url, {
        method: 'GET',
    }).then(res => {
        return Promise.resolve(res);
    });
  }
  saveRat(rat) {
    return this.fetch(`${this.domain}/incubation/rat`, {
        method: 'POST',
        body: JSON.stringify({
          rat,
        })
    }).then(res => {
        return Promise.resolve(res);
    });
  }
  saveRm(rm) {
    return this.fetch(`${this.domain}/incubation/rm`, {
        method: 'POST',
        body: JSON.stringify({
          rm,
        })
    }).then(res => {
        return Promise.resolve(res);
    });
  }
  saveRt(rt) {
    return this.fetch(`${this.domain}/incubation/rt`, {
        method: 'POST',
        body: JSON.stringify({
          rt,
        })
    }).then(res => {
        return Promise.resolve(res);
    });
  }
  getRATList(id) {
    const url = new URL(`${this.domain}/incubation/rat`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
  getRTList(id) {
    const url = new URL(`${this.domain}/incubation/rt`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
  getRMList(id) {
    const url = new URL(`${this.domain}/incubation/rm`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
  getSSList(id) {
    const url = new URL(`${this.domain}/incubation/ss`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
  getSAFList(id) {
    const url = new URL(`${this.domain}/incubation/saf`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
  saveSs(ss) {
    return this.fetch(`${this.domain}/incubation/ss`, {
        method: 'POST',
        body: JSON.stringify({
          ss,
        })
    }).then(res => {
        return Promise.resolve(res);
    });
  }
  saveSaf(saf) {
    return this.fetch(`${this.domain}/incubation/saf`, {
        method: 'POST',
        body: JSON.stringify({
          saf,
        })
    }).then(res => {
        return Promise.resolve(res);
    });
  }
  getSSById(id) {
    const url = new URL(`${this.domain}/incubation/ss/byid`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
  getSAFById(id) {
    const url = new URL(`${this.domain}/incubation/saf/byid`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  postContrato(contrato) {
    const data = new FormData();
    data.append('file', contrato.archivo);
    data.append('ventas', contrato.ventas);
    data.append('acciones', contrato.acciones);
    data.append('canon', contrato.canon);
    data.append('vencimiento', contrato.vencimiento);
    data.append('contrato', contrato.contrato);
    data.append('nombre', contrato.nombre);
    data.append('idproyectoincubacion', contrato.idproyectoincubacion);
    data.append('id', contrato.id);

    return fetch(`${this.domain}/incubation/contract`, {
          headers : {'Authorization':'Bearer ' + this.getToken()},
          method: 'POST',
          body: data,
        })
        .then(this._checkStatus)
        .then( response => {
          return Promise.resolve(response);
        });
  }

  getUsersContracts(id) {
    const url = new URL(`${this.domain}/incubation/proyect/users-contracts`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  postFactura(factura, idproyecto) {
    const formdata = new FormData();
    formdata.append('idproyectoincubacion', idproyecto);
    formdata.append('file', factura.archivo);
    formdata.append('alicuotaiva', factura.alicuotaiva);
    formdata.append('concepto', factura.concepto);
    formdata.append('cuit', factura.cuit);
    formdata.append('fecha', factura.fecha);
    formdata.append('estado', factura.estado);
    formdata.append('ingresosbrutos', factura.ingresosbrutos);
    formdata.append('iva', factura.iva);
    formdata.append('neto', factura.neto);
    formdata.append('numero', factura.numero);
    formdata.append('proveedor', factura.proveedor);
    formdata.append('rendida', factura.rendida);
    formdata.append('subtipo', factura.subtipo);
    formdata.append('tipo', factura.tipo);
    formdata.append('total', factura.total);
    formdata.append('idfactura', factura.idfactura);
    formdata.append('otrosconceptos', factura.otrosconceptos);
    formdata.append('condicioniva', factura.condicioniva);
    formdata.append('alicuotaib', factura.alicuotaib);
    return fetch(`${this.domain}/incubation/factura`, {
          headers : {'Authorization':'Bearer ' + this.getToken()},
          method: 'POST',
          body: formdata,
        })
        .then(this._checkStatus)
        .then( response => {
          return Promise.resolve(response);
        });
  }

  getFacturasCompra(id) {
    const url = new URL(`${this.domain}/incubation/facturas/compras`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  getFacturasVenta(id) {
    const url = new URL(`${this.domain}/incubation/facturas/ventas`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  getActualContract(id) {
    const url = new URL(`${this.domain}/incubation/actual-contract`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  getRendiciones(id) {
    const url = new URL(`${this.domain}/incubation/rendiciones`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  postRendiciones(rendicion) {
      return this.fetch(`${this.domain}/incubation/rendicion`, {
          method: 'POST',
          body: JSON.stringify({
            rendicion,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  getContractById(id) {
    const url = new URL(`${this.domain}/incubation/contract`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  getFacturaById(id) {
    const url = new URL(`${this.domain}/incubation/factura`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  getUserLoginContract(id) {
    const url = new URL(`${this.domain}/incubation/proyect/actual-contract-user`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  signContract(idmiembro, idcontrato) {
      return this.fetch(`${this.domain}/incubation/sign-contract`, {
          method: 'PUT',
          body: JSON.stringify({
            sign: {idmiembro, idcontrato},
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  getAnnouncementNumbers() {
    const url = new URL(`${this.domain}/incubation/announcements/numbers`);
    url.search = new URLSearchParams()
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  getProjectsStatus() {
    const url = new URL(`${this.domain}/incubation/status`);
    url.search = new URLSearchParams()
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  updateRTSign(id, signed, column) {
    const url = new URL(`${this.domain}/incubation/rt/update-sign`);
    return this.fetch(url, {
      method: 'PUT',
      body: JSON.stringify({
        id,
        signed,
        column,
      })
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  updateRMSign(id, signed, column) {
    const url = new URL(`${this.domain}/incubation/rm/update-sign`);
    return this.fetch(url, {
      method: 'PUT',
      body: JSON.stringify({
        id,
        signed,
        column,
      })
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/IncubationService.js